import { gql } from '@apollo/client';
import { useGetOrganizationExpirationDataLazyQuery } from '@generated/graphql';
import { calculateDateDifference } from '@helper-functions/calculateDateDifference';
import { useCurrentOrganizationId } from '@navigation/WorkspaceContext';
import { ExpiredModal } from '@subsets/landing-page/organization/expiration';
import { useEffect } from 'react';

gql`
  query GetOrganizationExpirationData($organizationId: String) {
    getOrganizations(organizationId: $organizationId) {
      role
      expirationDate
      expired
      organizationId
    }
  }
`;

export const WorkspacesExpirationsModal = () => {
  const organizationId = useCurrentOrganizationId();
  const [getOrganization, { data: organizationsData, loading: organizationsLoading }] =
    useGetOrganizationExpirationDataLazyQuery();

  useEffect(() => {
    if (!organizationId) {
      return;
    }
    void getOrganization({ variables: { organizationId } });
  }, [getOrganization, organizationId]);

  const organization = organizationsData?.getOrganizations?.[0];

  if (!organization) {
    return null;
  }

  const { hours } = calculateDateDifference(organization?.expirationDate);

  const isExpired = organization?.expired || hours < 1;

  if (!organizationsLoading && isExpired) {
    return <ExpiredModal workspacesPage organizationId={organizationId} />;
  }
  return null;
};
